const generateQuickGuid = ()=> {
    return Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
}

const getShortUuid = () =>{
    return Math.random().toString(36).slice(-8);
}


export {
    generateQuickGuid, 
    getShortUuid
}; 